export enum CustomCheckboxState {
	TRUE = "true",
	FALSE = "false",
	INTERMEDIATE = "intermediate",
};